import axios from "axios";

const createTechDeliverDoc = async (body) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/TechDeliverDoc`, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllTechDeliverDoc = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechDeliverDoc`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechDeliverDoc = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechDeliverDoc/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getDocDeliverInform = async (params) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechDeliverDoc/docDeliveryInform${params || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editTechDeliverDoc = async (id, body) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/TechDeliverDoc/${id}`, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteTechDeliverDoc = async (id) => {
  return axios
    .delete(`${process.env.REACT_APP_API_URL}/TechDeliverDoc/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const TechDeliverDocService = {
  createTechDeliverDoc,
  getAllTechDeliverDoc,
  getTechDeliverDoc,
  getDocDeliverInform,
  editTechDeliverDoc,
  deleteTechDeliverDoc
};

export default TechDeliverDocService;
